export default __webpack_public_path__ + "static/media/sort-desc-icon.44f4f8a3.svg";